import React from "react";

export const DetailsIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.34375 11.375H6.5V12.1875H9.34375V11.375Z" fill="#7F5CFF" />
      <path d="M12.1875 9.75H6.5V10.5625H12.1875V9.75Z" fill="#7F5CFF" />
      <path d="M12.1875 8.125H6.5V8.9375H12.1875V8.125Z" fill="#7F5CFF" />
      <path
        d="M1.625 8.125V8.9375H3.48806L0.8125 11.6131L1.38694 12.1875L4.0625 9.51194V11.375H4.875V8.125H1.625Z"
        fill="#7F5CFF"
      />
      <path
        d="M11.375 3.25H6.5L5.11302 1.86302C4.96063 1.71065 4.75396 1.62503 4.53846 1.625H1.625C1.40951 1.625 1.20285 1.7106 1.05048 1.86298C0.898102 2.01535 0.8125 2.22201 0.8125 2.4375V7.3125H1.625V2.4375H4.53846L5.92544 3.82448L6.16346 4.0625H11.375V7.3125H12.1875V4.0625C12.1875 3.84701 12.1019 3.64035 11.9495 3.48798C11.7972 3.3356 11.5905 3.25 11.375 3.25Z"
        fill="#7F5CFF"
      />
    </svg>
  );
};
